export default "__VITE_ASSET__CW8a78S3__"